import { formatDistanceToNow, isValid } from 'date-fns';

/** Avoid date-fns RangeError when Firestore timestamps deserialize oddly. */
export function safeFormatRelativeTime(value: Date | undefined | null): string {
  if (!value || !isValid(value)) return '';
  try {
    return formatDistanceToNow(value, { addSuffix: true });
  } catch {
    return '';
  }
}
